// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"35":"2122a8b6ee47477c95f2","144":"a3028ceb443db186f8f4","228":"3fc27d0790ef6ffb4dec","290":"4972268687ba1a047772","313":"1659e90f282eea0f8d78","356":"3159de1d606025104878","645":"3733f7c98e53ff17ed1c","919":"6cc4f04613e3c69e3c2a"}[chunkId] + ".chunk.js";
};